import { gql } from '@apollo/client';

export const SECURITY_CONTEXT_FIELDS = gql`
  fragment SecurityContextFields on SecurityContext {
    userId
    userEmail
    userPartyRole
    language
    partyName
    partyId
    partyType
    createdAt
    updatedAt
    expiresAt
  }
`;

export const AUTHENTICATION_FIELDS = gql`
  ${SECURITY_CONTEXT_FIELDS}
  fragment AuthenticationFields on Authentication {
    token
    securityContext {
      ...SecurityContextFields
    }
  }
`;
